import { render, staticRenderFns } from "./CorrectionOfPrevPolicyDetail.vue?vue&type=template&id=2536c2d8"
import script from "./CorrectionOfPrevPolicyDetail.vue?vue&type=script&lang=js"
export * from "./CorrectionOfPrevPolicyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports